module.exports = {
      id: "instagram-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.56e2db0a.svg#instagram-usage",
      toString: function () {
        return this.url;
      }
    }